import React, { useRef } from 'react'
import { View } from 'react-native'
import Carousel from 'react-native-snap-carousel'
import CarouselItem from './CarouselItem'
import { useDimensions } from '../../../hooks/useDimensions'
import { IconButton } from '../../../components'
import { carouselStyles as styles } from './styles'
import Identity from '../../../utils/Identity'
import { usePlatforms } from '../../../hooks/usePlatforms'

const AuthCarousel = () => {
  const carouselRef = useRef(null)
  const { width } = useDimensions()
  const { isTablet } = usePlatforms()

  const items = [
    {
      title: 'CAPACITY is a freight-matching platform providing an easy, accessible way for Edge carriers to book and bid on loads, view shipments, process payments, and much more. With its simple, user-friendly interface, CAPACITY speeds up carriers booking and bidding processes giving you the time to focus on your business.',
      keywords: [
        'Instant Capacity',
        'Dedicated Truckload Solutions',
        'Managed Transportation Solutions'
      ],
      titleStyle: {
        ...Identity.Font(isTablet).h2,
        lineHeight: 35
      }
    },
    {
      title: 'Edge Logistics Launches Digital Freight-Matching Platform Capacity',
      keywords: [
        'Instant Capacity',
        'Dedicated Truckload Solutions',
        'Managed Transportation Solutions'
      ],
      link: 'https://finance.yahoo.com/news/edge-logistics-launches-digital-freight-165404274.html',
      icon: 'YahooLogo',
      titleStyle: Identity.Font(isTablet).h
    },
    {
      title: 'Digital Freight-Matching Platform Capacity',
      keywords: [
        'Instant Capacity',
        'Dedicated Truckload Solutions',
        'Managed Transportation Solutions'
      ],
      link: 'https://www.freightwaves.com/news/edge-logistics-launches-digital-freight-matching-platform-capacity',
      icon: 'FreightWavesLogo',
      titleStyle: Identity.Font(isTablet).h
    }
  ]

  const goNext = () => {
    const { current } = carouselRef
    current && current.snapToNext()
  }
  const goPrevious = () => {
    const { current } = carouselRef
    current && current.snapToPrev()
  }

  return (
    <View style={styles.container}>
      <IconButton
        icon='AngleLeft'
        color='WHITE_TEXT'
        iconColor='SECONDARY_BUNKER'
        size={25}
        iconSize={12}
        onPress={goPrevious}
        style={{ marginRight: 10 }}
      />
      <Carousel
        ref={carouselRef}
        data={items}
        firstItem={0}
        renderItem={({ item }) => (
          <CarouselItem item={item} />
        )}
        sliderWidth={(width * 0.6) - 170}
        itemWidth={(width * 0.6) - 170}
        slideStyle={styles.itemContainer}
        scrollEnabled={false}
        useScrollView
        loop
      />
      <IconButton
        icon='AngleRight'
        color='WHITE_TEXT'
        iconColor='SECONDARY_BUNKER'
        size={25}
        iconSize={12}
        onPress={goNext}
        style={{ marginLeft: 5 }}
      />
    </View>
  )
}

export default AuthCarousel
